const ISPyB = {
  sites: [
    {
      name: 'SOLEIL',
      server: 'http://vedette-ng.synchrotron-soleil.fr:8081/ispyb/ispyb-ws/rest',
      description: 'SOLEIL Synchrotron',
      icon: '../images/site/soleil-logo.png',
      dataAnalysis: {
        enabled: true,
        url: 'https://is4a.esrf.fr',
        // url: "http://lindemaria:8000"
      },
      settings: {
        themes: [
          'cerulean',
          'cosmo',
          'cyborg',
          'darkly',
          'flatly',
          'journal',
          'lumen',
          'paper',
          'readable',
          'sandstone',
          'simplex',
          'slate',
          'spacelab',
          'superhero',
          'united',
          'yeti',
        ],
        MX: {
          showQualityIndicatorPlot: true, // It shows or hides the quality indicator plot from the summary tab of a datacollection
          showCollectionTab: true,
          showCrystalSnapshot1: true,
          showCrystalSnapshot2: true,
          showCrystalSnapshot3: true,
          showCrystalSnapshot4: true,
        },
      },
      beamlines: {
        SAXS: [
          {
            name: 'SWING',
          },
        ],
        EM: [],
        MX: [
          {
            name: 'PROXIMA1',
            sampleChangerType: '',
          },
          {
            name: 'PROXIMA2A',
            sampleChangerType: '',
          },
        ],
      },
    },
  ],
}

export default ISPyB
